export const GLOBAL_CONSTANTS = {
  BUTTON: 'button',
  PRIMARY: 'primary',
  SUBMIT: 'submit',
  CONTAINED: 'contained',
  IS_INVALID: 'is-invalid',
  DELETE: 'Delete',
  CANCEL: 'Cancel',
  DELETE_CONFIRM: 'Are you sure you want to delete',
  EDIT: 'Edit',
  INVALID_DATE: 'Invalid date',
  LOGOUT: 'Logout',
  SAVE: 'Save',
};
